import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Lightning, EnvelopeSimple } from "@phosphor-icons/react";

const BG = "https://images.unsplash.com/photo-1559619081-8fd2cc754ca3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative h-full flex flex-col justify-end p-12">
          <Lightning size={40} weight="fill" color="#FF007F" />
          <h2 className="font-display text-4xl font-black uppercase mt-4 leading-tight">Reset your<br />password</h2>
        </div>
      </div>
      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <h1 className="font-display text-3xl font-black uppercase mb-1">Forgot Password</h1>
          {sent ? (
            <div data-testid="forgot-sent">
              <div className="flex items-center gap-2 text-[#39FF14] mt-6 mb-3">
                <EnvelopeSimple size={22} weight="fill" />
                <span className="font-bold uppercase tracking-widest text-sm">Check your email</span>
              </div>
              <p className="text-zinc-400 text-sm">If an account exists for <span className="text-white">{email}</span>, we've sent a link to reset your password. It expires in 1 hour.</p>
              <p className="text-zinc-500 text-xs mt-3">Don't see it? Check your spam folder.</p>
              <Link to="/login" className="inline-block mt-6 text-[#00FFFF] underline text-sm">Back to log in</Link>
            </div>
          ) : (
            <form onSubmit={submit}>
              <p className="text-zinc-400 text-sm mb-6">Enter your email and we'll send you a link to reset your password.</p>
              {err && <p className="text-[#FF007F] text-sm mb-4 border border-[#FF007F] p-2" data-testid="forgot-error">{err}</p>}
              <label className="text-xs uppercase tracking-widest text-zinc-400">Email</label>
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required data-testid="forgot-email"
                className="w-full mt-1 mb-6 bg-zinc-900 border border-zinc-700 focus:border-[#00FFFF] outline-none px-3 py-3 text-white" />
              <button type="submit" disabled={busy} data-testid="forgot-submit"
                className="w-full py-3 bg-[#FF007F] text-white font-black uppercase tracking-widest border border-[#FF007F] hover:bg-[#09090B] hover:text-[#FF007F] transition-colors disabled:opacity-50">
                {busy ? "Sending…" : "Send Reset Link"}
              </button>
              <p className="text-sm text-zinc-400 mt-4">Remembered it? <Link to="/login" className="text-[#00FFFF] underline">Log in</Link></p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
